import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'curbnturf-rating-pill',
  templateUrl: './rating-pill.component.html',
  styleUrls: ['./rating-pill.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RatingPillComponent),
      multi: true,
    },
  ],
  standalone: true,
})
export class RatingPillComponent {
  @Input() selected: boolean = false;

  @Input() label: string;

  @Input() disabled: boolean = false;

  @Output() selectChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  onChange: (id?: boolean) => void = () => {
    /**/
  };
  onTouched: (id?: boolean) => void = () => {
    /**/
  };

  writeValue(obj: boolean): void {
    this.selected = obj;
  }

  registerOnChange(fn: (id?: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: (id?: boolean) => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  select(value: boolean) {
    if (!this.disabled) {
      this.selected = value;
      this.selectChange.emit(this.selected);
      this.onChange(this.selected);
      this.onTouched();
    }
  }
}
